import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-PreFunction',
    templateUrl: './PreFunction.component.html'
})
export class PreFunctionComponent implements OnInit {

    consumerID: string;
    functions: [];

    data = {
        'consumerID' : this.consumerID,
        'functions' : this.functions,
        'plugin' : 'pre-function'
    };

    constructor() { }
    PreFunction() {
    }

    ngOnInit() {
    }

}
